"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeForInsightView = exports.configForInsightView = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var geoConfigCodeGenerator_1 = require("../../components/pluggableVisualizations/geoChart/geoConfigCodeGenerator");
/**
 * @internal
 */
function configForInsightView(insight) {
    if (geoConfigCodeGenerator_1.isGeoChart(insight)) {
        return geoConfigCodeGenerator_1.geoConfigForInsightViewComponent();
    }
}
exports.configForInsightView = configForInsightView;
function localeForInsightView(ctx) {
    var _a;
    var val = sdk_ui_1.resolveLocale((_a = ctx === null || ctx === void 0 ? void 0 : ctx.settings) === null || _a === void 0 ? void 0 : _a.locale);
    return {
        value: val !== sdk_ui_1.DefaultLocale ? val : undefined,
        meta: {
            cardinality: "scalar",
        },
    };
}
exports.localeForInsightView = localeForInsightView;
//# sourceMappingURL=insightViewConfig.js.map